import { __rest } from '../../_virtual/_tslib.js';
import React from 'react';
import { fComp } from '../../utils/React.js';
import { IconLinkWrapper } from '../IconLink/IconLinkWrapper.js';
import '../IconLink/IconLinkPresentation.js';
import { IconLinkGroupWrapper } from '../IconLinkGroup/IconLinkGroupWrapper.js';
import '../IconLinkGroup/IconLinkGroupPresentation.js';
import '../NavigationLink/NavigationLinkPresentation.js';
import { NavigationLinkWrapper } from '../NavigationLink/NavigationLinkWrapper.js';
import { NavigationLinkGroupPresentation } from '../NavigationLinkGroup/NavigationLinkGroupPresentation.js';
import { hostClass } from './NavigationBar.styles.js';

var defaultProps = {
  onChange: function onChange() {
    /* empty */
  },
  size: "menu"
};
var NavigationBarPresentation = fComp(function (props) {
  var className = props.className,
      navigationTree = props.navigationTree,
      onChange = props.onChange,
      value = props.value,
      activeRef = props.activeRef,
      size = props.size,
      centeredLayout = props.centeredLayout;

  var internalOnClick = function internalOnClick(e, name, item) {
    onChange(name, e);

    if (item.onClick) {
      item.onClick(e, name);
    }
  };

  if (size !== "menu") {
    return /*#__PURE__*/React.createElement(NavigationLinkGroupPresentation, {
      noMargin: true,
      className: hostClass,
      size: size,
      centeredLayout: centeredLayout
    }, navigationTree === null || navigationTree === void 0 ? void 0 : navigationTree.map(function (_a) {
      var label = _a.label,
          item = __rest(_a, ["label"]);

      return /*#__PURE__*/React.createElement(NavigationLinkWrapper, Object.assign({}, item, {
        key: "key".concat(item.name),
        onClick: function onClick(e, name) {
          return internalOnClick(e, name, item);
        },
        secondary: value && value !== item.name,
        actionRef: value === item.name ? activeRef : undefined
      }), label);
    }));
  }

  return /*#__PURE__*/React.createElement(IconLinkGroupWrapper, {
    direction: "header-menu",
    noMargin: true,
    className: className
  }, navigationTree === null || navigationTree === void 0 ? void 0 : navigationTree.map(function (_a) {
    var label = _a.label,
        showBadge = _a.showBadge,
        item = __rest(_a, ["label", "showBadge"]);

    return /*#__PURE__*/React.createElement(IconLinkWrapper, Object.assign({}, item, {
      key: "key".concat(item.name),
      onClick: function onClick(event, name) {
        return onChange(name, event);
      },
      secondary: value && value !== item.name,
      actionRef: value === item.name ? activeRef : undefined
    }), showBadge && /*#__PURE__*/React.createElement("div", {
      className: "".concat(hostClass, "-badge-wrapper")
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(hostClass, "-badge")
    }), /*#__PURE__*/React.createElement("div", null, label)) || label);
  }));
}, defaultProps);

export { NavigationBarPresentation };
